import { Grid } from "@cloudscape-design/components";
import "./SignIn.css";

type SignInProps = {
    setShowModal: (v: boolean) => void;
}

export const SignIn = ({ setShowModal }: SignInProps) => {
    return (
        <>
            <Grid
                gridDefinition={[{ colspan: { l: 8, m: 8, default: 12 } }, { colspan: { l: 4, m: 4, default: 0 } }]}
                disableGutters
            >
                <div className="signin--left-column">
                    <div className="signin--left-column-content ">
                        <div className="signin--title">SIGN IN TO CONTINUE</div>
                        <div className="signin--subtitle">It only takes few more steps <br />to redeem your exclusive gift!</div>
                        <div className="signin--buttons-wrapper">
                            <div className="signin--custom-button" onClick={() => { setShowModal(true) }}>SIGN IN</div>
                        </div>
                    </div>
                </div>
                <div className="signin--right-column">
                    <img className="signin--big-giraffe-image" src="/images/chose_your_role.png" alt="Chose your role giraffe" />
                </div>
            </Grid>
        </>
    )
}